import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  onBoardingSetProp: ['key', 'value'],

  setSelectedPlan: ['selectedPlan'],
  focusPlan: ['focusPlan'],
  focusPlanReset: null,

  setSwitchPlan: ['switchPlan'],

  countriesRequest: null,
  countriesSuccess: ['countries'],

  saveBillingAddress: ['presetBillingAddress'],
  clearBillingAddress: null,

  checkDiscountCodeRequest: ['code'],
  checkDiscountCodeSuccess: ['discountResult'],
  checkDiscountCodeFailure: ['discountError'],
  checkDiscountCodeReset: null,

  saveSubscriptionRequest: ['data'],
  saveSubscriptionSuccess: ['saveSubscriptionResult'],
  saveSubscriptionFailure: ['saveSubscriptionError'],
  saveSubscriptionSecure: ['saveSubscription3DS'],
  changeSubscriptionReset: null,

  updateSubscriptionRequest: ['data'],
  updateSubscriptionSuccess: ['updateSubscriptionResult'],
  updateSubscriptionFailure: ['updateSubscriptionError'],
  updateSubscriptionSecure: ['updateSubscription3DS'],

  deleteSubscriptionRequest: null,
  deleteSubscriptionSuccess: ['deleteSubscriptionResult'],
  deleteSubscriptionFailure: ['deleteSubscriptionError'],

  undoDeleteSubscriptionRequest: ['data'],
  undoDeleteSubscriptionSuccess: ['undoDeleteSubscriptionResult'],
  undoDeleteSubscriptionFailure: ['undoDeleteSubscriptionError'],

  setPaymentCardFetching: ['paymentCardFetching'],

  onBoardingFetchingReset: null,
  logout: null,

  setCompletelyFinishedOnboarding: null
});

export const OnboardingTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  completelyFinishedOnboarding: false,

  tempSubscription: null,

  selectedPlan: null,
  focusPlan: null,

  switchPlan: null,

  countries: null,
  countriesFetching: false,

  presetBillingAddress: null,

  discountResult: null,
  discountError: null,
  discountFetching: false,

  saveSubscriptionResult: null,
  saveSubscriptionError: null,
  saveSubscription3DS: null,
  saveSubscriptionFetching: false,

  updateSubscriptionResult: null,
  updateSubscriptionError: null,
  updateSubscription3DS: null,
  updateSubscriptionFetching: false,

  deleteSubscriptionResult: null,
  deleteSubscriptionError: null,
  deleteSubscriptionFetching: false,

  undoDeleteSubscriptionResult: null,
  undoDeleteSubscriptionError: null,
  undoDeleteSubscriptionFetching: false,

  paymentCardFetching: false,
});

/* ------------- Selectors ------------- */
export const getState = (state) => state.onBoarding;

export const onBoardingSetProp = (state, { key, value }) => {
  const obj = {};
  obj[key] = value;

  return state.merge(obj);
};

export const setSelectedPlan = (state, { selectedPlan }) =>
  state.merge({ selectedPlan });
export const focusPlan = (state, { focusPlan }) => state.merge({ focusPlan });
export const focusPlanReset = (state, {}) => state.merge({ focusPlan: null });

export const setSwitchPlan = (state, { switchPlan }) => {
  if (switchPlan) {
    return state.merge({ switchPlan });
  }
  return state.merge({ switchPlan: null });
};

export const countriesRequest = (state, {}) =>
  state.merge({ countriesFetching: true });
export const countriesSuccess = (state, { countries }) =>
  state.merge({ countriesFetching: false, countries });

export const saveBillingAddress = (state, { presetBillingAddress }) =>
  state.merge({ presetBillingAddress });
export const clearBillingAddress = (state, {}) =>
  state.merge({ presetBillingAddress: null });

export const checkDiscountCodeRequest = (state, { code }) =>
  state.merge({ discountFetching: true });
export const checkDiscountCodeSuccess = (state, { discountResult }) =>
  state.merge({ discountFetching: false, discountResult });
export const checkDiscountCodeFailure = (state, { discountError }) =>
  state.merge({ discountFetching: false, discountError });
export const checkDiscountCodeReset = (state, {}) =>
  state.merge({ discountResult: null, discountError: null });

export const saveSubscriptionRequest = (state, { data }) =>
  state.merge({ saveSubscriptionFetching: true });
export const saveSubscriptionSuccess = (state, { saveSubscriptionResult }) =>
  state.merge({
    saveSubscriptionFetching: false,
    saveSubscriptionResult,

    //selectedPlan: null,
    //focusPlan: null,
  });
export const saveSubscriptionFailure = (state, { saveSubscriptionError }) =>
  state.merge({ saveSubscriptionFetching: false, saveSubscriptionError });

export const saveSubscriptionSecure = (state, { saveSubscription3DS }) =>
  state.merge({ saveSubscriptionFetching: false, saveSubscription3DS });

export const changeSubscriptionReset = (state, {}) =>
  state.merge({
    saveSubscriptionFetching: false,
    saveSubscriptionResult: null,
    saveSubscriptionError: null,
    saveSubscription3DS: null,

    updateSubscriptionFetching: false,
    updateSubscriptionResult: null,
    updateSubscriptionError: null,
    updateSubscription3DS: null,

    deleteSubscriptionFetching: false,
    deleteSubscriptionResult: null,
    deleteSubscriptionError: null,

    undoDeleteSubscriptionFetching: false,
    undoDeleteSubscriptionResult: null,
    undoDeleteSubscriptionError: null,
  });

export const updateSubscriptionRequest = (state, { data }) =>
  state.merge({ updateSubscriptionFetching: true, tempSubscription: data });
export const updateSubscriptionSuccess = (
  state,
  { updateSubscriptionResult },
) =>
  state.merge({
    updateSubscriptionFetching: false,
    updateSubscriptionResult,

    switchPlan: null,
  });
export const updateSubscriptionFailure = (state, { updateSubscriptionError }) =>
  state.merge({ updateSubscriptionFetching: false, updateSubscriptionError, tempSubscription: null });

export const updateSubscriptionSecure = (state, { updateSubscription3DS }) =>
  state.merge({ updateSubscriptionFetching: false, updateSubscription3DS });

export const deleteSubscriptionRequest = (state) =>
  state.merge({ deleteSubscriptionFetching: true });
export const deleteSubscriptionSuccess = (state, { deleteSubscriptionResult }) =>
  state.merge({
    deleteSubscriptionFetching: false,
    deleteSubscriptionResult,
    switchPlan: null,
  });
export const deleteSubscriptionFailure = (state, { deleteSubscriptionError }) =>
  state.merge({ deleteSubscriptionFetching: false, deleteSubscriptionError });

export const undoDeleteSubscriptionRequest = (state, { data }) =>
  state.merge({ undoDeleteSubscriptionFetching: true });
export const undoDeleteSubscriptionSuccess = (state, { undoDeleteSubscriptionResult }) =>
  state.merge({
    undoDeleteSubscriptionFetching: false,
    undoDeleteSubscriptionResult,
  });
export const undoDeleteSubscriptionFailure = (state, { undoDeleteSubscriptionError }) =>
  state.merge({
    undoDeleteSubscriptionFetching: false,
    undoDeleteSubscriptionError,
  });

export const onBoardingFetchingReset = (state) =>
  state.merge({
    countriesFetching: false,
    discountFetching: false,
    saveSubscriptionFetching: false,
    updateSubscriptionFetching: false,
    deleteSubscriptionFetching: false,
    undoDeleteSubscriptionFetching: false,
    intentFetching: false,
    paymentCardFetching: false,
  });

export const setPaymentCardFetching = (state, { paymentCardFetching }) =>
  state.merge({ paymentCardFetching });

export const logout = (state) => INITIAL_STATE;

export const setCompletelyFinishedOnboarding = (state) => {
  console.log(state);
  return state.merge({ completelyFinishedOnboarding: true });
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.ON_BOARDING_SET_PROP]: onBoardingSetProp,

  [Types.SET_SELECTED_PLAN]: setSelectedPlan,

  [Types.SET_SWITCH_PLAN]: setSwitchPlan,

  [Types.FOCUS_PLAN]: focusPlan,
  [Types.FOCUS_PLAN_RESET]: focusPlanReset,

  [Types.COUNTRIES_REQUEST]: countriesRequest,
  [Types.COUNTRIES_SUCCESS]: countriesSuccess,

  [Types.SAVE_BILLING_ADDRESS]: saveBillingAddress,
  [Types.CLEAR_BILLING_ADDRESS]: clearBillingAddress,

  [Types.CHECK_DISCOUNT_CODE_REQUEST]: checkDiscountCodeRequest,
  [Types.CHECK_DISCOUNT_CODE_SUCCESS]: checkDiscountCodeSuccess,
  [Types.CHECK_DISCOUNT_CODE_FAILURE]: checkDiscountCodeFailure,
  [Types.CHECK_DISCOUNT_CODE_RESET]: checkDiscountCodeReset,

  [Types.SAVE_SUBSCRIPTION_REQUEST]: saveSubscriptionRequest,
  [Types.SAVE_SUBSCRIPTION_SUCCESS]: saveSubscriptionSuccess,
  [Types.SAVE_SUBSCRIPTION_FAILURE]: saveSubscriptionFailure,
  [Types.SAVE_SUBSCRIPTION_SECURE]: saveSubscriptionSecure,

  [Types.UPDATE_SUBSCRIPTION_REQUEST]: updateSubscriptionRequest,
  [Types.UPDATE_SUBSCRIPTION_SUCCESS]: updateSubscriptionSuccess,
  [Types.UPDATE_SUBSCRIPTION_FAILURE]: updateSubscriptionFailure,
  [Types.UPDATE_SUBSCRIPTION_SECURE]: updateSubscriptionSecure,

  [Types.DELETE_SUBSCRIPTION_REQUEST]: deleteSubscriptionRequest,
  [Types.DELETE_SUBSCRIPTION_SUCCESS]: deleteSubscriptionSuccess,
  [Types.DELETE_SUBSCRIPTION_FAILURE]: deleteSubscriptionFailure,

  [Types.UNDO_DELETE_SUBSCRIPTION_REQUEST]: undoDeleteSubscriptionRequest,
  [Types.UNDO_DELETE_SUBSCRIPTION_SUCCESS]: undoDeleteSubscriptionSuccess,
  [Types.UNDO_DELETE_SUBSCRIPTION_FAILURE]: undoDeleteSubscriptionFailure,

  [Types.CHANGE_SUBSCRIPTION_RESET]: changeSubscriptionReset,

  [Types.ON_BOARDING_FETCHING_RESET]: onBoardingFetchingReset,

  [Types.SET_PAYMENT_CARD_FETCHING]: setPaymentCardFetching,

  [Types.LOGOUT]: logout,

  [Types.SET_COMPLETELY_FINISHED_ONBOARDING]: setCompletelyFinishedOnboarding,
});
